<!-- 過去のファイル。
デマンド機能がMaasJAPANのticketing機能と連動しており
BFFにAPIを投げて該当サービスに使えるticketing情報を整理して
支払い方法(ticketing/クレカ/現地払い/無料)を選択する -->
<template>
  <div>
    <div v-if="isReady" class="each-divisions-payment">
      <!-- デバッグ表示:<br>
      possession_ticket_count: {{possession_ticket_count}}<br><br>
      using_ticket_count:{{using_ticket_count}}<br><br>
      payment_method_divisions:{{payment_method_divisions}}<br><br>
      tickets_data:{{tickets_data}}<br><br>
      available_tickets: {{available_tickets}} -->

      <!-- 定期券・1日券両方持っている場合 -->
      <div class="select-wrap" v-for="n of seatCount.adult" :key="'adult' + n">
        <label for="">おとな 1名 </label>
        <select
          v-model="payment_method_divisions.adult[n - 1]"
          @change="calcTickets()"
          name=""
          id=""
        >
          <option
            v-if="
              using_ticket_count != possession_ticket_count ||
              payment_method_divisions.adult[n - 1] == 'ticket'
            "
            value="ticket"
          >
            1回券
          </option>
          <option value="onsite">車内でお支払い</option>
          <option value="card">事前決済（クレジットカード）</option>
        </select>
      </div>

      <div class="select-wrap" v-for="n of seatCount.child" :key="'child' + n">
        <label for="">こども 1名</label>
        <select
          v-model="payment_method_divisions.child[n - 1]"
          @change="calcTickets()"
          name=""
          id=""
        >
          <option
            v-if="
              using_ticket_count != possession_ticket_count ||
              payment_method_divisions.child[n - 1] == 'ticket'
            "
            value="ticket"
          >
            1回券
          </option>
          <option value="onsite">車内でお支払い</option>
          <option value="card">事前決済（クレジットカード）</option>
        </select>
      </div>

      <div
        class="select-wrap"
        v-for="n of seatCount.infant"
        :key="'infant' + n"
      >
        <label for="">幼児 1名 </label>
        <select
          v-model="payment_method_divisions.infant[n - 1]"
          @change="calcTickets()"
          :disabled="payment_method_divisions.infant[n - 1] == 'free'"
          name=""
          id=""
        >
          <option
            v-if="payment_method_divisions.infant[n - 1] == 'free'"
            value="free"
          >
            無料
          </option>
          <option
            v-if="
              using_ticket_count != possession_ticket_count ||
              payment_method_divisions.infant[n - 1] == 'ticket'
            "
            value="ticket"
          >
            1回券
          </option>
          <option value="onsite">車内でお支払い</option>
          <option value="card">事前決済（クレジットカード）</option>
        </select>
      </div>
    </div>

    <!-- 定期券・1日券両方持っている場合 -->

    <!-- ローディングダイアログ -->
    <ItemDialog
      v-else
      ref="loadingDialog"
      imageType="loader"
      :initialOpen="true"
    >
      <template v-slot:content-area>
        <h2>{{ $t("common.loading") }}</h2>
      </template>
    </ItemDialog>
    <!-- ローディングダイアログ -->

    <!-- API通信失敗ダイアログ -->
    <ItemDialog ref="Fails" imageType="alert">
      <template v-slot:content-area>
        <h2>エラーが発生しました</h2>
        <p class="text-center">お手数ですが最初からやり直してください</p>
      </template>
      <template v-slot:button-area>
        <button class="btn button-primary" @click="gotoIndex()">
          <span> 戻る </span>
        </button>
      </template>
    </ItemDialog>
    <!-- API通信失敗ダイアログ -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TheDemandEbusDivisionPayment",

  data() {
    return {
      // GET APIのレスポンスのObjectを格納するデータ
      available_tickets: null,

      // 今回使用すると洗濯しているチケット数
      using_ticket_count: 0,

      // divisionごとの支払い方法管理配列
      payment_method_divisions: {},

      // 使えるチケットのmaster_book_id,master_pass_idのセットになった配列
      tickets_data: [],

      // 持ってるチケット数
      possession_ticket_count: 0,

      // ページ描画フラグ
      isReady: false,
    };
  },
  async created() {
    // 初期値を設定する関数を実行
    await this.setTickets();

    // 初期に所持しているチケット
    this.possession_ticket_count = 0;

    this.available_tickets.forEach((ticket) => {
      this.possession_ticket_count += ticket.counts.adult;
    });
  },
  mounted() {
    // 親コンポーネントに初期値を吐き出し
    this.$emit("parentMethod", this.payment_method_divisions);
  },
  methods: {
    // 初期値を設定する関数を実行
    async setTickets() {
      try {
        // トークン再取得
        this.getTokens();

        // 使えるsingleチケットor定期券があるかチェック
        this.available_tickets = await this.$store.dispatch(
          "demand/getDemandSelectBoxOptions",
          {
            id: this.selectedService.master_bookingservice_id,
          }
        );
      } catch (err) {
        this.$refs.Fails.open();
      }

      var that = this;
      var adult_method = [];
      var child_method = [];
      var infant_method = [];

      var a_count = this.seatCount.adult ? this.seatCount.adult : 0;
      var c_count = this.seatCount.child ? this.seatCount.child : 0;

      if (this.available_tickets == undefined) {
        // 有効なチケットを持ってない場合は車内でお支払い指定
        // 幼児は1に対して2無料
        for (let i = 0; i < this.seatCount.adult; i++) {
          adult_method.push("onsite");
        }
        this.payment_method_divisions["adult"] = adult_method;

        for (let i = 0; i < this.seatCount.child; i++) {
          child_method.push("onsite");
        }
        this.payment_method_divisions["child"] = child_method;

        for (let i = 0; i < this.seatCount.infant; i++) {
          // おとな・小人の数によって幼児のチケットが無料になる
          if (a_count + c_count > 1) {
            infant_method.push("free");
          } else {
            if (i < 2) {
              infant_method.push("free");
            } else {
              infant_method.push("onsite");
            }
          }
        }
        this.payment_method_divisions["infant"] = infant_method;
      } else {
        this.available_tickets.forEach((ticket) => {
          that.possession_ticket_count += ticket.counts.adult;

          for (var i = 0; i < ticket.counts.adult; i++) {
            this.tickets_data.push({
              master_book_id: ticket.master_book_id,
              master_pass_id: ticket.master_pass_id,
            });
          }
        });

        for (let i = 0; i < that.seatCount.adult; i++) {
          if (that.possession_ticket_count > 0) {
            adult_method.push("ticket");
            that.possession_ticket_count--;
            that.using_ticket_count++;
          } else {
            adult_method.push("onsite");
          }
        }
        that.payment_method_divisions["adult"] = adult_method;

        for (let i = 0; i < that.seatCount.child; i++) {
          if (that.possession_ticket_count > 0) {
            child_method.push("ticket");
            that.possession_ticket_count--;
            that.using_ticket_count++;
          } else {
            child_method.push("onsite");
          }
        }
        that.payment_method_divisions["child"] = child_method;

        for (let i = 0; i < this.seatCount.infant; i++) {
          // おとな・小人の数によって幼児のチケットが無料になる
          if (a_count + c_count > 1) {
            // 2以上なら全部無料(5人乗りなので)
            infant_method.push("free");
          } else {
            if (i < 2) {
              infant_method.push("free");
            } else {
              if (that.possession_ticket_count > 0) {
                infant_method.push("ticket");
                that.possession_ticket_count--;
                that.using_ticket_count++;
              } else {
                infant_method.push("onsite");
              }
            }
          }
        }
        that.payment_method_divisions["infant"] = infant_method;
      }
      this.$emit(
        "parentMethod1",
        this.payment_method_divisions,
        this.tickets_data
      );
      this.isReady = true;
    },

    calcTickets() {
      // 親コンポーネトへ吐き出し
      var array1 = this.payment_method_divisions.adult.concat(
        this.payment_method_divisions.child,
        this.payment_method_divisions.infant
      );

      // selectの選択肢で計算するので、使っているチケットの数整理をして
      this.using_ticket_count = array1.filter(function (x) {
        return x == "ticket";
      }).length;

      if (array1.includes("card") && array1.includes("onsite")) {
        this.$emit("parentMethod2", true);
      } else {
        this.$emit("parentMethod2", false);
      }
      this.$emit(
        "parentMethod1",
        this.payment_method_divisions,
        this.tickets_data
      );
    },

    gotoIndex() {
      this.$router.push({
        name: "DemandIndex",
      });
    },
  },
  computed: {
    ...mapGetters("demand", [
      "selectedService",
      "demandToken",
      "busStops",
      "pickUpBusstopId",
      "dropOffBusstopId",
      "seatCount",
      "pickUpTime",
    ]),
  },
};
</script>

<style lang="scss" scoped>
.each-divisions-payment {
  width: 90%;
  margin: 20px auto 0;
  div {
    padding: 5px 0;
  }
  label {
    color: #999999;
    width: 40%;
    letter-spacing: 0.2rem;
    display: inline-block;
  }
  select {
    position: relative;
    display: inline-block;
    width: 60%;
    border-color: #c6c6c6;
    font-size: 1rem;
    height: 2.5rem;
    padding: 0 5px;
    background: white;
    -webkit-appearance: none;
  }
  select:disabled {
    border-color: #e0e0e0;
    background-color: #f0f0f0;
    color: #000000;
    -webkit-appearance: none; /* ベンダープレフィックス(Google Chrome、Safari用) */
    -moz-appearance: none; /* ベンダープレフィックス(Firefox用) */
    appearance: none; /* 標準のスタイルを無効にする */
  }

  .select-wrap {
    width: 100%;
    position: relative;
    display: inline-block;
    border-radius: 0;
  }

  .select-wrap::after {
    content: "";
    width: 6px;
    height: 6px;
    border: 0px;
    border-bottom: solid 2px #b4b3b3;
    border-right: solid 2px #b4b3b3;
    -ms-transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    position: absolute;
    top: 25px;
    right: 15px;
    margin-top: -6px;
  }
}
</style>
